import React from "react";
import { FormEnabler, ValidatedForm, MInput, MSelect, MTextArea } from "components/forms";
import { contactService, dateHelper, networkErrorHelper, payloadBuilder } from "libs";
import { BoxSuccess } from "components/misc";

export class ContactRequestForm extends ValidatedForm {
  constructor(props) {
    super(props);

    this.state = {
      ...this.emptyFields,
      defaultValues: { ...this.emptyFields },
      formActive: true,
      rndKey: 0,
      isSuccess: false,
      submittedData: null,
      datesNoWorking: [],
      isSubmitting: false,
    };
  }

  emptyFields = {
    surname: "",
    name: "",
    email: "",
    phone: "",
    idSubject: "",
    date: "",
    idHour: "",
    body: "",
  };

  PAYLOADS = {
    subjects: [{ label: "Seleziona un argomento", value: "" }],
    hours: [{ label: "Seleziona prima una data", value: "" }],
  };

  ERROR_MESSAGES = {
    surname: "Cognome obbligatorio",
    name: "Nome obbligatorio",
    email: "L'email non può essere vuota",
    phone: "Cellulare obbligatorio",
    idSubject: "Selezionare l'argomento",
    date: "Data non valida: scegli un giorno lavorativo nei prossimi 5 giorni (esclusi weekend e festivi).",
    idHour: "Selezionare la fascia oraria",
    body: "La domanda non può essere vuota",
  };

  validation = {
    surname: (value) => value !== "" && value !== null,
    name: (value) => value !== "" && value !== null,
    email: (value) => value !== "" && /\S+@\S+\.\S+/.test(value),
    phone: (value) => value !== "" && value !== null,
    idSubject: (value) => value !== "" && value !== null,
    date: (value) => {
      if (!value) return false;

      const selectedDate = new Date(value);
      selectedDate.setHours(0, 0, 0, 0);

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const maxDate = new Date();
      maxDate.setDate(today.getDate() + 5);
      maxDate.setHours(0, 0, 0, 0);

      if (selectedDate < today || selectedDate > maxDate) {
        return false;
      }

      const day = selectedDate.getDay();
      if (day === 0 || day === 6) {
        return false;
      }

      if (this.state.datesNoWorking && this.state.datesNoWorking.includes(value)) {
        return false;
      }

      return true;
    },
    idHour: (value) => value !== "" && value !== null,
    body: (value) => value !== "" && value !== null,
  };

  FIELDS_GROUP = [
    [
      {
        id: "surname",
        field: "surname",
        label: "Cognome",
        component: MInput,
        className: "col-sm-6",
      },
      {
        id: "name",
        field: "name",
        label: "Nome",
        component: MInput,
        className: "col-sm-6",
      },
    ],
    [
      {
        id: "email",
        field: "email",
        label: "Email",
        component: MInput,
        type: "email",
        className: "col-sm-6",
      },
      {
        id: "phone",
        field: "phone",
        label: "Telefono",
        component: MInput,
        type: "tel",
        className: "col-sm-6",
      },
    ],
    [
      {
        id: "idSubject",
        field: "idSubject",
        label: "Argomento",
        component: MSelect,
        payload: { options: this.PAYLOADS.subjects },
        className: "col-sm-6",
      },
    ],
    [
      {
        id: "date",
        field: "date",
        label: "Data",
        component: MInput,
        type: "date",
        className: "col-sm-6",
        infoText: "Scegli un giorno lavorativo nei prossimi 5 giorni",
        onChange: (id, value) => this.onDateChange(id, value),
      },
      {
        id: "idHour",
        field: "idHour",
        label: "Fascia oraria",
        component: MSelect,
        payload: { options: this.PAYLOADS.hours },
        className: "col-sm-6",
      },
    ],
    [
      {
        id: "body",
        field: "body",
        label: "Domanda",
        component: MTextArea,
        className: "col-sm-12",
        rows: "4",
      },
    ],
  ];

  loadRemoteSubjects() {
    const { aa } = this.props;

    contactService
      .listSubjects(aa)
      .then(({ data }) => {
        this.PAYLOADS.subjects.length = 1;

        if (data.payload && data.payload.subjects) {
          data.payload.subjects.forEach((s) => {
            this.PAYLOADS.subjects.push({ label: s.value, value: s.id });
          });
        }

        this.setState({ rndKey: Math.floor(Math.random() * 1000 + 1) });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
      });
  }

  loadRemoteDatesNoWorking() {
    const { aa } = this.props;
    contactService
      .listDatesNoWorking(aa)
      .then(({ data }) => {
        if (data.payload && data.payload.dates) {
          this.setState({ datesNoWorking: data.payload.dates });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  loadRemoteHours(date) {
    const { aa } = this.props;
    this.PAYLOADS.hours.length = 1;

    if (!date) {
      this.PAYLOADS.hours[0] = { label: "Seleziona prima una data", value: "" };
      this.setState({ rndKey: Math.floor(Math.random() * 1000 + 1) });
      return;
    }

    contactService
      .listHours(aa, date)
      .then(({ data }) => {
        this.PAYLOADS.hours[0] = { label: "Seleziona una fascia oraria", value: "" };
        if (data.payload && data.payload.hours) {
          data.payload.hours.forEach((h) => {
            this.PAYLOADS.hours.push({
              label: `${h.start} - ${h.end}`,
              value: String(h.id),
            });
          });
        }
        this.setState({ rndKey: Math.floor(Math.random() * 1000 + 1) });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
      });
  }

  componentDidMount() {
    this.loadRemoteSubjects();
    this.loadRemoteDatesNoWorking();
  }

  onDateChange = (id, value) => {
    this.setState({ idHour: "" });
    this.PAYLOADS.hours.length = 1;

    if (!value) return;

    if (this.validation.date(value)) {
      this.loadRemoteHours(value);
    } else {
      this.setState({ rndKey: Math.floor(Math.random() * 1000 + 1) });
    }
  };

  onSubmit = (e) => {
    if (e) e.preventDefault();
    if (!this.checkValidation()) return;

    this.saveRemote();
  };

  saveRemote = () => {
    const { aa } = this.props;
    const data = payloadBuilder(this.state);
    data.dbYear = aa;

    this.setState({ isSubmitting: true });

    contactService
      .insertRequest(data)
      .then(() => {
        const selectedHour = this.PAYLOADS.hours.find((h) => h.value === data.idHour);

        this.setState({
          isSuccess: true,
          isSubmitting: false,
          formActive: false,
          submittedData: {
            date: data.date,
            phone: data.phone,
            hourLabel: selectedHour ? selectedHour.label : "",
          },
        });
      })
      .catch((errors) => {
        console.log(errors);
        this.setState({ isSubmitting: false });
        networkErrorHelper.notify(errors);
      });
  };

  renderSuccess() {
    const { submittedData } = this.state;

    return (
      <>
        {submittedData && (
          <BoxSuccess>
            <b>Richiesta inserita</b>
            <p className="mt-3">
              Sarai chiamato il giorno <b>{dateHelper.toITDate(submittedData.date)}</b> nella fascia oraria <b>{submittedData.hourLabel}</b> al numero{" "}
              <b>{submittedData.phone}</b>.
            </p>
          </BoxSuccess>
        )}
      </>
    );
  }

  render() {
    let { formActive, defaultValues, rndKey, isSuccess, isSubmitting } = this.state;

    if (isSuccess) {
      return this.renderSuccess();
    }

    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, formActive);

    return (
      <div key={rndKey} className="p-2 my-3">
        <form className="user">{code}</form>

        <div className="mt-4">
          <FormEnabler
            onSubmit={this.onSubmit}
            hideCancel={true}
            isFormActive={formActive}
            disableSave={isSubmitting}
            buttonText={isSubmitting ? "Invio in corso..." : "Invia"}
          />
        </div>
      </div>
    );
  }
}
